<template>
<div class="chapter">
<div class="inner_page">
<p><a id="toc"></a></p>
<div class="fmh1">Table of Contents</div>
<div> <br/></div>
<div class="cfmh"><a href="#/kriw_9781590206102_oeb_tp_r1">Title Page</a></div>
<div class="cbmh"><a href="#/kriw_9781590206102_oeb_cop_r1">Copyright Page</a></div>
<div class="cfmh"><a href="#/kriw_9781590206102_oeb_prf_r1">IMPORTANT PREFACE TO THE SECOND EDITION</a></div>
<div class="cfmh"><a href="#/kriw_9781590206102_oeb_ded_r1">Dedication</a></div>
<div class="cfmh"><a href="#/kriw_9781590206102_oeb_ack_r1">Acknowledgements</a></div>
<div class="cfmh"><a href="#/kriw_9781590206102_oeb_itr_r1">Introduction</a></div>
<div> <br/></div>
<div class="cct"><span href="#/kriw_9781590206102_oeb_c01_r1" title="Link target outside of Sample">TEXT NUMBER ONE - On the Dancing Death of Amanda Palmer</span></div>
<div class="cct"><span href="#/kriw_9781590206102_oeb_c02_r1" title="Link target outside of Sample">TEXT NUMBER TWO - On the Strange Case of the Death of Amanda Palmer</span></div>
<div class="cct"><span href="#/kriw_9781590206102_oeb_c03_r1" title="Link target outside of Sample">TEXT NUMBER THREE - One Day Last Week I Met Amanda Palmer</span></div>
<div class="cct"><span href="#/kriw_9781590206102_oeb_c04_r1" title="Link target outside of Sample">TEXT NUMBER FOUR - On the Near Perfect Death of Amanda Palmer</span></div>
<div class="cct"><span href="#/kriw_9781590206102_oeb_c05_r1" title="Link target outside of Sample">TEXT NUMBER FIVE - On the Unsung Death of Amanda Palmer</span></div>
<div class="cct"><span href="#/kriw_9781590206102_oeb_c06_r1" title="Link target outside of Sample">TEXT NUMBER SIX - On the Aesthetic Decline of the Mock-Funeral</span></div>
<div class="cct"><span href="#/kriw_9781590206102_oeb_c07_r1" title="Link target outside of Sample">TEXT NUMBER SEVEN - On the Unreported Death of Amanda Palmer</span></div>
<div class="cct"><span href="#/kriw_9781590206102_oeb_c08_r1" title="Link target outside of Sample">TEXT NUMBER EIGHT - On the Exultant Death of Amanda Palmer</span></div>
<div class="cct"><span href="#/kriw_9781590206102_oeb_c09_r1" title="Link target outside of Sample">TEXT NUMBER NINE</span></div>
<div class="cct"><span href="#/kriw_9781590206102_oeb_c10_r1" title="Link target outside of Sample">TEXT NUMBER TEN - Upon the Death of Amanda Palmer</span></div>
<div> <br/></div>
<div class="cbmh"><span href="#/kriw_9781590206102_oeb_bm1_r1" title="Link target outside of Sample">ON THE MANY CRIMES OF TOBIAS JAMES</span></div>
<div class="apt"><span href="#/kriw_9781590206102_oeb_ap1_r1" title="Link target outside of Sample">APPENDIX I - Editor’s Introduction to the Appendices</span></div>
<div class="apt"><span href="#/kriw_9781590206102_oeb_ap2_r1" title="Link target outside of Sample">APPENDIX II - The Case Against “Tobias James”</span></div>
<div class="apt"><span href="#/kriw_9781590206102_oeb_ap3_r1" title="Link target outside of Sample">APPENDIX III - Who Is Tobias James?—a brief biography</span></div>
<div class="apt"><span href="#/kriw_9781590206102_oeb_ap4_r1" title="Link target outside of Sample">APPENDIX IV - On the Writing of Tobias James—a Psychological Analysis</span></div>
<div class="apt"><span href="#/kriw_9781590206102_oeb_ap5_r1" title="Link target outside of Sample">APPENDIX V - A Brief Comment on the Many Rumours and Speculations Surrounding  ...</span></div>
<div class="cbmh"><span href="#/kriw_9781590206102_oeb_bm2_r1" title="Link target outside of Sample">POSTSCRIPT</span></div>
<div class="cbmh"><span href="#/kriw_9781590206102_oeb_ata_r1" title="Link target outside of Sample">About the Editor</span></div>
<div class="cbmh"><span href="#/kriw_9781590206102_oeb_bm3_r1" title="Link target outside of Sample">Also by Rohan Kriwaczek:</span></div>
<div class="cbmh"><span href="#/kriw_9781590206102_oeb_bm4_r1" title="Link target outside of Sample">Recordings by Rohan Kriwaczek</span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// kriw_9781590206102_oeb_toc_r1.vue?1b7e64fb